/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useIntl} from 'react-intl'
import {CardLoading} from '../../../../../../../../../_metronic/partials/widgets/loading/CardLoading'

type Props = {
  className: string
  expiration_date?: string
  limit_renovation?: string
  issue_date?: string

  issue_cost: string
  maintenance_cost: string
  renovation_cost: string
}

const CardSystemWidgetOneLicense2: React.FC<Props> = ({
  className,
  expiration_date,
  limit_renovation,
  issue_date,

  issue_cost,
  maintenance_cost,
  renovation_cost,
}) => {
  // const [total, setTotal] = useState('')
  const intl = useIntl()

  return (
    <div
      className={`card w-100 h-100 ${className} 
    border          
          border-gray-300                   
          `}
    >
      {/* begin::Body */}
      <div className='card-body d-flex flex-column py-xxl-1 py-lg-4'>
        {issue_date ? (
          <>
            {/* begin::Row */}
            <div className='row mt-xxl-3 mb-xxl-0 mb-lg-0 '>
              <p className='fw-bold fs-4'>{intl.formatMessage({id: 'LICENSES.TITLE_CARD'})}</p>

              <div className='col-xl-4  mb-lg-2 fs-8 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='text-dark mt-2'>
                    {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
                  </div>
                  <div className=' text-gray-600 p-1 '>{issue_date}</div>
                </div>
              </div>

              <div className='col-xl-4  mb-lg-2 fs-8 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='text-dark mt-2'>
                    {intl.formatMessage({id: 'LICENSES.EXPIRATION_DATE'})}
                  </div>
                  <div className=' text-gray-600 p-1'>{expiration_date}</div>
                </div>
              </div>

              <div className='col-xl-4  mb-lg-2 fs-8 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2 text-dark'>
                    {intl.formatMessage({id: 'LICENSES.LIMIT_DATE_RENEW'})}
                  </div>
                  <div className=' text-success p-1'>{limit_renovation}</div>
                </div>
              </div>

              <div className='col-xl-4  mb-xl-2 mb-xxl-2 mb-lg-n1 fs-8 fw-bold  '>
                <div className='rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2  '>{intl.formatMessage({id: 'LICENSES.ISSUE_COST'})}</div>
                  <div className='mb-3 text-primary fs-6'>{'R$ ' + issue_cost}</div>
                </div>
              </div>

              <div className='col-xl-4  mb-xl-2 mb-xxl-2 mb-lg-n1 fs-9 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2'>
                    {intl.formatMessage({id: 'LICENSES.COST_MAINTENANCE'})}
                  </div>
                  <div className=' mb-3 text-success fs-6'>{'R$ ' + maintenance_cost}</div>
                </div>
              </div>

              <div className='col-xl-4 mb-xl-2 mb-xxl-2 mb-lg-n1 fs-9 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2 '>{intl.formatMessage({id: 'LICENSES.COST_RENEWAL'})}</div>
                  <div className='fs-6 text-info mb-3'>{'R$ ' + renovation_cost}</div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <CardLoading />
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetOneLicense2}
